
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { IPageDetailPayload } from '@src/types/api/page';


export async function savePage(data: IPageDetailPayload): Promise<AxiosResponse<TResponse<IPageDetailPayload>>> {
    return axios.post<TResponse<IPageDetailPayload>>(API_ENDPOINTS.SAVE_PAGE, data)
}

export async function pageDetail(type: string): Promise<AxiosResponse<TResponse<IPageDetailPayload>>> {
    return axios.get(`${API_ENDPOINTS.PAGE_DETAIL}/${type}`)
}